require('./bootstrap');

import flatpickr from "flatpickr";
flatpickr(".datepicker");

document.addEventListener("DOMContentLoaded", function(){
    // make it as accordion for smaller screens
    if (window.innerWidth < 992) {

        // close all inner dropdowns when parent is closed
        document.querySelectorAll('.navbar .dropdown').forEach(function(everydropdown){
        everydropdown.addEventListener('hidden.bs.dropdown', function () {
            // after dropdown is hidden, then find all submenus
            this.querySelectorAll('.submenu').forEach(function(everysubmenu){
                // hide every submenu as well
                everysubmenu.style.display = 'none';
            });
        })
        });

        document.querySelectorAll('.dropdown-menu a').forEach(function(element){
        element.addEventListener('click', function (e) {
            let nextEl = this.nextElementSibling;
            if(nextEl && nextEl.classList.contains('submenu')) {	
                // prevent opening link if link needs to open dropdown
                e.preventDefault();
                if(nextEl.style.display == 'block'){
                nextEl.style.display = 'none';
                } else {
                nextEl.style.display = 'block';
                }

            }
        });
        })
    }
    // end if innerWidth
}); 
// DOMContentLoaded  end

//back to top
$("#back_top_top").click(function () {
    //1 second of animation time
    //html works for FFX but not Chrome
    //body works for Chrome but not FFX
    //This strange selector seems to work universally
    $("html, body").animate({scrollTop: 0}, 100);
});

$('.post_popup_button').on('click', function() {
    $(this).next('.post_popup').css('display','flex');
});

/* Custom Upload Button */
/*
const uploadBtn = document.getElementById("upload-btn");
const customUploadBtn = document.querySelector(".custom-file-upload");

uploadBtn.addEventListener("change", function() {
  if (uploadBtn.value) {
    const fileName = uploadBtn.value.split("\\").pop();
    customUploadBtn.innerHTML = fileName;
  } else {
    customUploadBtn.innerHTML = "Choose a file";
  }
});
*/

$(document).ready(function () {
    if ($.fn.repeater) {
        $('.repeater').repeater();
    }

    $('.custom-delete').on("click", function() {
        $(this).parents(".custom-field-group").remove();
    });
});
